export default __webpack_public_path__ + "static/media/login.a604b10b.png";